import { z } from 'zod'

const createPasswordSchema = () =>
  z
    .string()
    .min(8, '8 символов')
    .regex(/^[^А-Яа-яЁё]*$/, 'Только латинские буквы')
    .regex(/[A-Z]/, '1 заглавная буква')
    .regex(/[a-z]/, '1 строчная буква')
    .regex(/[0-9]/, '1 цифра')
    .regex(/[@$!%*?&]/, '1 специальный символ (например, !, @, #, $ и т.д.)')

export const setNewPasswordFormSchema = z
  .object({
    password: createPasswordSchema(),
    confirmPassword: z.string(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'Пароли не совпадают',
    path: ['confirmPassword'],
  })
